// eslint-disable-next-line no-underscore-dangle
export const _1080x1350 = {
	name: 'Untitled 1080x1350 Template',
	variant: 'design',
	json: {
		width: 1080,
		height: 1350,
		fonts: [],
		pages: [
			{
				id: 'page_1',
				children: [],
				width: 'auto',
				height: 'auto',
				background: 'white',
				bleed: 0,
			},
		],
		unit: 'px',
		dpi: 96,
	},
	status: 'draft',
	history: [],
	tags$Category: [],
	tags$General: [
		'0:Medium:Digital',
		'0:Distribution:Social',
		'0:Format:Post',
		'0:Format:Ad',
		'0:Layout:Portrait',
		'0:Dimensions:1080x1350',
		'0:Network:Facebook',
		'0:Network:X',
		'0:Network:Instagram',
	],
	etc: {
		directives: {},
		cfg: {
			global: {
				minPages: 1,
				maxPages: 50,
			},
			customer: {
				minPages: 1,
				maxPages: 50,
			},
			order: {
				countries: null,
				itemId: '1080x1350',
			},
			canBeResized: true,
		},
	},
};

export default _1080x1350;
